// tslint:disable:max-line-length

import React from 'react';

export const ActionUpload = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,2c2.8,0,5,2.2,5,5l0,0v1c1.7,0,3,1.3,3,3s-1.3,3-3,3l0,0H9v-3h3L8,7l-4,4h3v3H4c-2.2,0-4-1.8-4-4c0-1.9,1.3-3.5,3.1-3.9 C3.5,3.8,5.5,2,8,2z" />
    </svg>
  );
};
